const Eye = ({ color, type }) => {
  const regular = (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4321 19C13.3781 19 14.2421 18.897 15.0301 18.719L13.2731 16.962C13.0001 16.983 12.7231 17 12.4321 17C7.08111 17 5.00811 13.154 4.50611 12C4.88305 11.1588 5.39215 10.3834 6.01411 9.70303L4.61611 8.30503C3.07811 9.97203 2.49511 11.651 2.48411 11.684C2.41513 11.8894 2.41513 12.1117 2.48411 12.317C2.50511 12.383 4.79911 19 12.4321 19ZM12.4321 5.00003C10.5951 5.00003 9.08611 5.39603 7.82811 5.98103L4.13911 2.29303L2.72511 3.70703L20.7251 21.707L22.1391 20.293L18.8201 16.974C21.4341 15.023 22.3671 12.359 22.3811 12.317C22.4501 12.1117 22.4501 11.8894 22.3811 11.684C22.3591 11.617 20.0651 5.00003 12.4321 5.00003ZM17.4041 15.558L15.1241 13.278C15.3141 12.888 15.4321 12.459 15.4321 12C15.4321 10.359 14.0731 9.00003 12.4321 9.00003C11.9731 9.00003 11.5441 9.11803 11.1551 9.30903L9.34711 7.50103C10.3396 7.16044 11.3828 6.99103 12.4321 7.00003C17.7831 7.00003 19.8561 10.846 20.3581 12C20.0561 12.692 19.1921 14.342 17.4041 15.558Z"
        fill={color}
      />
    </svg>
  );

  const solid = (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.69458 12.194L4.83358 8.33303C3.31358 9.99003 2.73758 11.65 2.72758 11.684L2.62158 12L2.72658 12.316C2.74858 12.383 5.04258 19 12.6756 19C13.6046 19 14.4506 18.898 15.2276 18.727L12.4816 15.981C11.4929 15.9326 10.5575 15.518 9.85756 14.818C9.1576 14.1181 8.74305 13.1827 8.69458 12.194ZM12.6756 5.00003C10.8206 5.00003 9.30058 5.40403 8.03358 5.99803L4.32858 2.29303L2.91458 3.70703L20.9146 21.707L22.3286 20.293L19.0306 16.995C21.6686 15.042 22.6096 12.358 22.6236 12.316L22.7286 12L22.6236 11.684C22.6016 11.617 20.3086 5.00003 12.6756 5.00003ZM14.5816 12.546C14.7686 11.869 14.6096 11.107 14.0896 10.586C13.5696 10.065 12.8066 9.90703 12.1296 10.094L10.6216 8.58603C11.2395 8.20601 11.9501 8.00328 12.6756 8.00003C14.8816 8.00003 16.6756 9.79403 16.6756 12C16.6726 12.7253 16.4695 13.4358 16.0886 14.053L14.5816 12.546Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Eye;
